<template>
    <div>
        <div v-for="(messages, index) in inbox">
            <label class="mail-group-label">{{ index }}</label>
            <ul v-for="(message, index) in messages" class="list-unstyled media-list mg-b-0">
                <inbox-list-message :message="message"/>
            </ul>
        </div>
    </div>
</template>

<script>
	export default {
		mounted() {},
		data() {
			return {};
		},
		computed: {
			inbox() {
				return _.groupBy(this.messages, message => {
					const date = moment(message.updated_at, "YYYY-MM-DD").calendar(
						null,
						{
							sameDay: "[Today], MMM D",
							lastDay: "[Yesterday], MMM D",
							lastWeek: "[Last] dddd, MMM D",
							sameElse: "MMMM D YYYY"
						}
					);

					return date;
				});
			}
		},
		methods: {},
		props: ["messages"]
	};
</script>

